import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import PageNotFound from './views/PageNotFound.vue'
import TopUp from './views/TopUp.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/api',
      name: 'api',
      component: () => import('./views/Api.vue')
    },
    {
      path: '/brand',
      name: 'brand',
      component: () => import('./views/Brand2.vue')
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product.vue')
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('./views/Order.vue')
    },
    {
      path: '/order-v2',
      name: 'orderv2',
      component: () => import('./views/Order2.vue')
    },
    {
      path: '/transaction',
      name: 'trans',
      component: () => import('./views/Trans.vue')
    },
    {
      path: '/transaction-v2',
      name: 'transv2',
      component: () => import('./views/Trans2.vue')
    },
    {
      path: '/dtc-success',
      name: 'dtc-success',
      component: () => import('./views/DtcSuccess.vue')
    },
    {
      path: '/dtc-failed',
      name: 'dtc-failed',
      component: () => import('./views/DtcFailed.vue')
    },
    {
      path: '/voucher-usage',
      name: 'voucher',
      component: () => import('./views/v2/Voucher.vue')
    },
    {
      path: '/callback',
      name: 'callback',
      component: () => import('./views/v2/Callback.vue')
    },
    {
      path: '/balance-history',
      name: 'balance',
      component: () => import('./views/v2/Balance.vue')
    },
    {
      path: '/topup',
      name: 'topup',
      component: TopUp
    },
    {
      path: '*',
      name: 'notFound',
      component: PageNotFound
    }
  ]
})
